import { Component, Input, EventEmitter, Output } from '@angular/core';

import { SecondMs } from 'rev-shared/date/Time.Constant';

import { IUserTag } from './IUserTag';

import styles from './InThisVideoEntry.module.less';

const MIN_ACTIVE_DURATION_MS: number = 1000;

export interface IInThisVIdeoEntryOnToggleEvent {
	tag: IUserTag;
}

export enum InThisVideoEntryLayout {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical'
}

@Component({
	selector: 'in-this-video-entry-angular',
	templateUrl: './InThisVideoEntryAngular.Component.html'
})
export class InThisVideoEntryAngularComponent {
	@Input() public activeUserTagId: string;
	@Input() public currentTimeSec: number;
	@Input() public entryLayout: InThisVideoEntryLayout;
	@Input() public tag: IUserTag;
	@Output() public onToggle: EventEmitter<IInThisVIdeoEntryOnToggleEvent> = new EventEmitter();

	public readonly styles = styles;

	public get isActiveTimeRage(): boolean {
		const currentTimeMs: number = this.currentTimeSec * SecondMs;

		return this.tag.timeRanges.some(range => {
			const { startTimeMs, endTimeMs } = range;

			const endTimeWithMinimumMs: number = Math.max(endTimeMs, startTimeMs + MIN_ACTIVE_DURATION_MS);

			return currentTimeMs >= startTimeMs && currentTimeMs <= endTimeWithMinimumMs;
		});
	}

	public get isVerticalLayout(): boolean {
		return this.entryLayout === InThisVideoEntryLayout.VERTICAL;
	}

	public onClick(): void {
		this.onToggle.emit({ tag: this.tag });
	}
}
